import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import 'antd/dist/antd.css'
import './RegisterContent.scss'
import {
  Card,
  Form,
  Input,
  Select,
  DatePicker
} from 'antd'
import Loading from '../../../components/Loading/Loading.jsx'
import ErrorHandler from '../../../utils/ErrorHandler'
import ButtonMain from '../../../components/ButtonMain/ButtonMain.jsx'
import { GetRegisterCheck, GetCheck3rdCrmData, GetRegister, GetRegisterWithThirdPartyCrm } from '../../../api/Register'
import { decrypt } from '../../../apiFunction/decrypt'
import city from '../../../assets/city/city.json'
import ConfirmHandler from '../../../utils/ConfirmHandler'
import moment from 'moment'
import zhTW from 'antd/es/date-picker/locale/zh_TW'
import 'moment/locale/zh-tw'
moment.locale('zh-tw')

export default function RegisterContent () {
  const { Option } = Select
  const [form] = Form.useForm()
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false)
  const history = useHistory()
  const [selectCity, setSelectCity] = useState('')
  const [selectDistricts, setSelectDistricts] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [confirmModalMsg, setConfirmModalMsg] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  /* eslint-disable no-useless-escape */
  const specialCharactersPattern = /^[^<>\/'"&;:{}[\]()*]+$/

  const handleCityChange = value => {
    city.map((item) => {
      if (value === item.name) {
        setSelectCity(item.name)
        setSelectDistricts(item.districts)
      }
      return true
    })
  }
  const RegisterAndShowErrorModal = async () => {
    form.validateFields()
      .then(fetchData)
      .catch(error => {
        const errorMsg = error.errorFields
        setIsErrorModalVisible(errorMsg)
      })
  }
  const handleOk = () => {
    setIsModalVisible(false)
  }
  async function fetchData (values) {
    setIsErrorModalVisible(false)
    setIsLoading(true)
    values.birthday = moment(values.birthday).format('YYYY/MM/DD')
    sessionStorage.setItem('Member_mobile_number', form.getFieldValue('phone'))
    const GetRegisterCheckMsg = await GetRegisterCheck(values)
    if (GetRegisterCheckMsg.rcrm.RC === 'MEMBER_MOBILE_IS_REPEAT') {
      setIsLoading(false)
      setIsModalVisible(true)
      setConfirmModalMsg('會員已存在 不可註冊')
    } else
    if (GetRegisterCheckMsg.rcrm.RC === 'C01') {
      const GetCheck3rdCrmDataMsg = await GetCheck3rdCrmData(values)
      const GetCheck3rdCrmDataMsgObj = JSON.parse(decrypt(GetCheck3rdCrmDataMsg.results.payload))
      if (GetCheck3rdCrmDataMsgObj.rcrm && GetCheck3rdCrmDataMsgObj.rcrm.RC === 'MEMBER_IS_NOT_EXIST') {
        const GetRegisterToken = await GetRegister(values)
        if (GetRegisterToken.rcrm.RC === 'C01') {
          sessionStorage.setItem('TEMP_ACCESS_TOKEN', GetRegisterToken.results.temp_access_token)
          history.push('/register/smsverification')
        } else {
          setIsLoading(false)
          setIsModalVisible(true)
          setConfirmModalMsg(GetRegisterToken.rcrm.RM)
        }
      }
      if (GetCheck3rdCrmDataMsgObj.third_party_crm_data && GetCheck3rdCrmDataMsgObj.third_party_crm_data.length === 1) {
        const check3rdCrmData = GetCheck3rdCrmDataMsgObj.third_party_crm_data[0]
        const CheckValuesName = values.name
        if (check3rdCrmData.name === CheckValuesName) {
          const GetRegisterToken = await GetRegisterWithThirdPartyCrm(values, check3rdCrmData)
          setIsLoading(false)
          if (GetRegisterToken.rcrm.RC === 'C01') {
            sessionStorage.setItem('TEMP_ACCESS_TOKEN', GetRegisterToken.results.temp_access_token)
            setConfirmModalMsg('註冊成功')
            history.push('/register/smsverification')
          } else {
            setConfirmModalMsg(`${GetRegisterToken.rcrm.RC}`)
          }
        } else {
          setIsLoading(false)
          setIsModalVisible(true)
          setConfirmModalMsg('親愛的會員您好，因會員資料有誤，請洽客服專線由專人為您處理：0800-559588')
        }
      } else
      if (GetCheck3rdCrmDataMsgObj.third_party_crm_data && GetCheck3rdCrmDataMsgObj.third_party_crm_data.length !== 1) {
        setIsModalVisible(true)
        setConfirmModalMsg('親愛的會員您好，因會員資料有誤，請洽客服專線由專人為您處理：0800-559588')
      }
    } else {
      setIsLoading(false)
      setIsModalVisible(true)
      setConfirmModalMsg(GetRegisterCheckMsg.rcrm.RM)
    }
  }
  return (
    <div className="site-card-border-less-wrapper">
      <Card title="我已經有會員帳號了?" bordered={false} extra={<Link to="/login">回登入頁</Link>}>
        {isErrorModalVisible ? <ErrorHandler errorList={isErrorModalVisible} /> : null}
        <Form
          form={form}
          name="register"
        >
          <Form.Item
            name="phone"
            label="手機號碼"
            rules={[
              {
                required: true,
                message: '手機號碼為必填!'
              },
              {
                pattern: /09\d{8}/,
                message: '請輸入正確的手機號!'
              }
            ]}
          >
            <Input placeholder="請輸入您的手機號" />
          </Form.Item>
          <Form.Item
            name="password"
            label="密碼"
            rules={[
              {
                required: true,
                message: '密碼為必填!'
              },
              {
                min: 6,
                message: '密碼須為 6-12 碼英數字混合'
              },
              {
                max: 12,
                message: '密碼須為 6-12 碼英數字混合'
              },
              {
                pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
                message: '密碼須為 6-12 碼英數字混合'
              }
            ]}
          >
            <Input.Password placeholder="6 - 12碼英數字混合" />
          </Form.Item>
          <Form.Item
            name="confirm"
            label="密碼確認"
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: '請再輸入一次密碼!'
              },
              ({ getFieldValue }) => ({
                validator (_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error('密碼輸入不一致!'))
                }
              })
            ]}
          >
            <Input.Password placeholder="請再輸入一次密碼" />
          </Form.Item>
          <Form.Item
            name="name"
            label="姓名"
            rules={[
              {
                required: true,
                message: '姓名為必填!'
              },
              {
                pattern: specialCharactersPattern,
                message: '姓名不能有特殊符號'
              }
            ]}
          >
            <Input placeholder="請輸入您的姓名" />
          </Form.Item>
          <Form.Item
            name="email"
            label="電子信箱"
            rules={[
              {
                required: true,
                message: 'E-mail為必填!'
              },
              {
                pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                message: '電子信箱格式不正確'
              }
            ]}
          >
            <Input placeholder="請輸入您的E-mail" />
          </Form.Item>
          <Form.Item
            name="forgetSecurity"
            label="忘記密碼安全問題"
            rules={[
              {
                required: true,
                message: '忘記密碼安全問題為必填!'
              }
            ]}
          >
            <Select placeholder="請輸入安全問題答案">
              <Option value="sq01">您畢業的國小</Option>
              <Option value="sq02">您最愛的寵物名字</Option>
              <Option value="sq03">您最愛的食物</Option>
              <Option value="sq04">您最好朋友的名字</Option>
              <Option value="sq05">您最愛的電影</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="security"
            label="安全問題答案"
            rules={[
              {
                required: true,
                message: '安全問題答案為必填!'
              },
              {
                pattern: specialCharactersPattern,
                message: '安全問題答案不能有特殊符號'
              }
            ]}
          >
            <Input placeholder="請輸入安全問題答案" />
          </Form.Item>
          <span className="notic">請正確填寫，註冊成功將無法修改</span>
          <Form.Item
            className="birthday"
            name="birthday"
            label="生日"
            rules={[
              {
                required: true,
                message: '生日為必填!'
              }
            ]}
          >
            <DatePicker format="YYYY/MM/DD" locale={zhTW} />
          </Form.Item>
          <Form.Item
            name="gender"
            label="性別"
            rules={[
              {
                required: true,
                message: '性別為必選!'
              }
            ]}
          >
            <Select placeholder="請輸入您的性別">
              <Option value="M">男性</Option>
              <Option value="F">女性</Option>
              <Option value="S">保密</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="city"
            label="通訊地址"
            rules={[
              {
                required: true,
                message: '縣市為必選!'
              }
            ]}
          >
            <Select placeholder="請輸入縣市" value={selectCity} onChange={handleCityChange}>
            {city.map(city => (
              <Option key={city.name}>{city.name}</Option>
            ))}

            </Select>
          </Form.Item>
          <Form.Item
            name="district"
            rules={[
              {
                required: true,
                message: '區域為必選!'
              }
            ]}
          >
            <Select placeholder="請輸入區域" disabled={!form.getFieldsValue('city')} value={selectDistricts[0]}>
              {selectDistricts !== '' && selectDistricts.map(districts => (
                <Option key={districts}>{districts}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="address"
            rules={[
              {
                required: true,
                message: '地址為必選!'
              },
              {
                pattern: specialCharactersPattern,
                message: '地址不能有特殊符號'
              }
            ]}
          >
            <Input placeholder="請輸入地址" />
          </Form.Item>
          <Form.Item>
            <ButtonMain buttonType="main" block onClick={RegisterAndShowErrorModal} value='Register'>
              註冊會員
            </ButtonMain>
          </Form.Item>
        </Form>
      </Card>
      <Card className="notice">
        <p>
          註冊表示同意 <a href="https://www.healthyfood.com.tw/pages/terms" target="_blank" rel="noreferrer">棉花田商店服務條款</a> 與 <a href="https://www.cyberbiz.io/terms-of-customer/" target="_blank" rel="noreferrer">會員責任規範及個資聲明</a>
        </p>
      </Card>
      {isModalVisible ? <ConfirmHandler title="提示" setModalvisible={isModalVisible} setHandleOk={handleOk} msg={confirmModalMsg} /> : null}
      <Loading isLoadingVisible={isLoading}>{isLoading}</Loading>
    </div>
  )
}
